/**
 * SmileFresh thank-you — Enhanced Conversions (user-provided data) for Google tag.
 * Install on /pages/thank-you-for-booking AFTER gtag/AW is loaded.
 *
 * Accepts Timely transactionId/value/description OR Shopify/theme bookingId +
 * email/phone/serviceName (live URL shape confirmed 10 Sep 2026).
 * Primary conversion stays GA4 booking_confirmed 6561224760.
 */
(function () {
  var q = new URLSearchParams(location.search);
  var transactionId =
    q.get('transactionId') ||
    q.get('transaction_id') ||
    q.get('bookingId') ||
    q.get('booking_id') ||
    '';
  var value = parseFloat(q.get('value') || '0') || 0;
  var description = q.get('description') || q.get('serviceName') || '';

  function fromSf() {
    var u = window.sfBookingUser || {};
    return { email: u.email || '', phone: u.phone || u.phone_number || '' };
  }

  var email = q.get('email') || fromSf().email || '';
  var phone = q.get('phone') || q.get('phone_number') || fromSf().phone || '';

  if (typeof gtag !== 'function') return;

  if (email || phone) {
    var ec = {};
    if (email) ec.email = email;
    if (phone) ec.phone_number = phone;
    gtag('set', 'user_data', ec);
  }

  if (transactionId) {
    try {
      gtag('event', 'booking_confirmed', {
        transaction_id: transactionId,
        value: value,
        currency: 'AUD',
        item_name: description || 'SmileFresh Booking'
      });
    } catch (e) {}
  }

  window.sfGadsEnhanced = {
    email: email || null,
    phone: phone || null,
    transactionId: transactionId || null
  };
})();
